import { AssetType } from '~/services/contests/enums/contests-assets.enums';

import { uploadImageAssetConfig } from '../../constants/upload-file.const';
import type { UploadImageFieldType } from '../../fields/StaticField/UploadImageField';

export const getBannerUploadField = (
  defaultValue?: string,
  customLabel?: string,
  customDescription?: string
): UploadImageFieldType => {
  const config = uploadImageAssetConfig[AssetType.CONTEST_BANNER];

  return {
    type: 'UploadImageField',
    key: 'banner',
    defaultValue,
    action: {
      edit: defaultValue ? 'Edit banner' : 'Upload banner',
      remove: 'Remove banner',
    },
    description:
      customDescription ||
      `
      Upload a contest banner up to <i>${
        config.fileSizeLimit.bytes
      } MB</i> with recommended dimensions of <i>${config.suggestedDimension.width}x${
        config.suggestedDimension.height
      } </i>pixels in <i>${config.formats.map((v) => v.toUpperCase()).join(', ')}</i> format.`,
    assetType: AssetType.CONTEST_BANNER,
    assetConfig: config,
    label: customLabel || 'Contest banner',
  };
};

export default getBannerUploadField;
